import { render } from "./company-selection.vue?vue&type=template&id=23b668c8"
import script from "./company-selection.vue?vue&type=script&lang=js"
export * from "./company-selection.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__